import { mergeProps, useFocusRing } from 'react-aria';
import styled from '@emotion/styled';

import { useDevice } from '../../../store/devices/useDevices.ts';
import { useOptionContext } from '../../list-box/ListBox';

import { theme } from '../../../theme/theme';

import { ListItem } from '../../list-box/ListItem';
import { TextNormal } from '../../common/text/TextNormal';
import { Icon } from '../../common/Icon';

import { iconWarning } from '../../../theme/icons/interface/warning/warning';

export function OptionDeviceDeviceControls(props) {
  // eslint-disable-next-line no-unused-vars
  const { ref, option, state, item, value } = useOptionContext();

  const focusRing = useFocusRing();

  const { device } = useDevice({ deviceId: item.key });

  return (
    <ListItem.Root
      {...mergeProps(option.optionProps, focusRing.focusProps)}
      ref={ref}
      className={props.className}
      style={{ '--indent-level': value.level }}
      as={props.as}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <S.Container
        style={{
          borderBottom: `1px solid ${
            state.collection.size === item.index + 1
              ? 'transparent'
              : item.index === 0
              ? theme.color.line
              : theme.color.line_light
          }`,
        }}
      >
        {device?.available === false && (
          <S.Icon
            url={iconWarning}
            size={theme.icon.size_default}
            color={device.group != null ? theme.color.yellow : theme.color.red}
          />
        )}

        <S.TextWrapper data-is-text-medium={item.key === state.selectedKey}>
          <TextNormal textAlign="center">{device?.name}</TextNormal>
        </S.TextWrapper>
      </S.Container>
    </ListItem.Root>
  );
}

const S = (OptionDeviceDeviceControls.S = class S {
  static Container = styled.div`
    display: flex;
    flex: 1 1 auto;
    height: 40px;
    align-items: center;
  `;

  static TextWrapper = styled.div`
    flex: 1 1 auto;
    min-width: 0;

    &[data-is-text-medium='true'] {
      ${TextNormal.S.Root} {
        font-weight: ${theme.fontWeight.medium};
      }
    }

    ${TextNormal.S.Root} {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `;

  static Icon = styled(Icon)`
    position: absolute;
    left: ${theme.su(1)};
    flex: 0 0 auto;
  `;
});
